import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {Link} from 'react-router-dom'
import Academicleft from '../Academic/Academicleft'


const AcademicCalenderEle = () => {
    const calendarsData = [

        {
            cname: "January - June 2025",
            url: 'https://files.iittp.ac.in/pdfs/calendar/2025/AC_Jan-June_2025.pdf',
            glow: true,
        },

        {
            cname: "July - December 2024",
            url: 'https://files.iittp.ac.in/pdfs/calendar/2024/Revised_AC_July-Dec_2024-10_09_2024.pdf',
            glow: true,
        },
        {
            cname: "January - June 2024",
            url: 'https://files.iittp.ac.in/pdfs/calendar/2024/Jan_June_2024_Revised_AC_12-4-2024.pdf',
            glow: false,
        },
        {
            cname: "July - Dec 2023 Calendar for B.Tech 2023 Batch Students",
            url: 'https://files.iittp.ac.in/pdfs/calendar/2023/Academic_Calendar_July-Dec 2023_B.Tech 2023 Batch.pdf',    
            glow: false,
        },
        {
            cname: "July - December 2023 (Except B.Tech 1st Semester Students)",
            url: 'https://files.iittp.ac.in/pdfs/calendar/2023/AC_16-12-2022_Jul-Dec 23_230705.pdf',    
            glow: false,
        },
        {
            cname: "January - June 2023",
            url: 'https://files.iittp.ac.in/pdfs/calendar/2023/AC_28-11-2022_Jan-Jun 23_230642.pdf',    
            glow: false,
        },
        {
            cname: "First Year 2022 Batch 2nd Semester",
            url: 'https://files.iittp.ac.in/pdfs/btech/2022/First year 2022 batch 2nd Semester_193719.pdf',    
        },
        {
            cname: "First Year 2022 Batch 1st Semester",
            url: 'https://files.iittp.ac.in/pdfs/btech/2022/First Year 2022 Batch 1st Semester_152847.pdf',    
        },
        {
            cname: "July - December 2022",
            url: 'https://files.iittp.ac.in/pdfs/calendar/2022/Academic_Calendar_July-Dec 2022.pdf',    
        },
        {
            cname: "January - June 2022",
            url: 'https://files.iittp.ac.in/pdfs/calendar/Academic_Calendar_Jan-June 2022.pdf',    
        },
        {
            cname: "First Year 2021 Batch 2nd Semester",
            url: 'https://files.iittp.ac.in/pdfs/calendar/Revised_Academic_Calendar_B.Tech_2021_2ndSem.pdf',    
        },
        {
            cname: "First Year 2021 Batch 1st Semester",
            url: 'https://files.iittp.ac.in/pdfs/btech/2021/Academic_Calendar_1st Sem_B.Tech 2021 Batch.pdf',    
        },
        {
            cname: "First Year 2020 Batch 2nd Semester",
            url: 'https://files.iittp.ac.in/pdfs/calendar/Academic Calendar  B.Tech  2nd semester.pdf',    
        },
        {
            cname: "January - June 2021",
            url: 'https://files.iittp.ac.in/pdfs/calendar/Academic_Calendar_Jan-June 2021.pdf',    
        },
        {
            cname: "July - December 2021",
            url: 'https://files.iittp.ac.in/pdfs/calendar/Academic_Calendar_July-Dec 2021.pdf',    
        },
        {
            cname: "First Year 2020 Batch",
            url: 'https://files.iittp.ac.in/pdfs/btech/2020/Acadmic Calendar - B.Tech 2020.pdf',    
        },
        {
            cname: "July - December 2020 (M.Tech, M.S/Ph.d, M.Sc))",
            url: 'https://files.iittp.ac.in/pdfs/calendar/Acadmic Calendar for July-Dec 2020 Semester - PG.pdf',    
        },
        {
            cname: "July - December 2020 (B.Tech)",
            url: 'https://files.iittp.ac.in/pdfs/calendar/Acadmic Calendar for July-Dec 2020 Semester - UG.pdf',    
        },
        {
            cname: "January - June 2020",
            url: 'https://files.iittp.ac.in/pdfs/calendar/IITTp_Academic_Calendar_Jan-June 2020.pdf',    
        },
        {
            cname: "July - December 2019",
            url: 'https://files.iittp.ac.in/pdfs/calendar/AcademicCalendarJuly-Dec2019.pdf',    
        },
        {
            cname: "January - July 2019",
            url: 'https://files.iittp.ac.in/pdfs/IITTP-Academic-Calendar-Jan-June2019.pdf',    
        },
        {
            cname: "July - December 2018",
            url: 'https://files.iittp.ac.in/images/demo/iit/calendar/IITTPAcademicCalendar-July-Dec2018.pdf',    
        },
        {
            cname: "January - June 2018",
            url: 'https://files.iittp.ac.in/images/demo/iit/calendar/IITTP-Academic-Calendar-Jan-June-2018.pdf',    
        },
        {
            cname: "July - December 2017",
            url: 'https://files.iittp.ac.in/images/demo/iit/calendar/IITTp_Academic_Calendar_July-Dec2017.pdf',    
        },
        {
            cname: "January - June 2017",
            url: 'https://files.iittp.ac.in/images/demo/iit/calendar/iittp_Academic_Calander_jan_may17.pdf',    
        },
        {
            cname: "July - December 2016",
            url: 'https://files.iittp.ac.in/images/demo/iit/calendar/Academic_calendar_july-dec-2016.pdf',    
        },
        {
            cname: "January - June 2016",
            url: 'https://files.iittp.ac.in/images/demo/iit/calendar/iittp_Academic_Calander_Jan-June2016.pdf',    
        },
        {
            cname: "July - December 2015",
            url: 'https://files.iittp.ac.in/images/demo/iit/calendar/iittp_Academic_Calendar_July-Dec2015.pdf',    
        },
    ];


    return (


        <section className="project-detail">
           <Container>
            <Row className='my-5'>

                <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Academicleft activeIndex={7} />
                </Col>
                <Col md={8} className='c-right'>

                    <h1 className='text-center'>Academic Calendar</h1>
                    <ul className='ms-4 mt-4 fs-5'>
                            {calendarsData.map((value, index) => {
                                return (
                                    <li className='c-lineheight3' key={index}>
                                        <i className="fas fa-file-pdf me-3 text-danger"></i>
                                        <Link to={value.url} target="_blank">
                                            <span className={value.glow ? 'glowing-text' : ''} >{value.cname}</span>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </Col>
                </Row>
            </Container>
        </section>
            
                     
     
    );
};


export default AcademicCalenderEle;
